import {ShieldCheck} from 'lucide-react';
import Container from '@/components/ui/Container';
import { partners, clients } from '@/data/certifications';

function TrustBar() {
  return (
    <section className="border-y border-slate-100 bg-slate-50 py-12" aria-label="Certificações e clientes">
      <Container>
        <p className="text-center text-xs font-semibold uppercase tracking-widest text-slate-400">
          Alguns de nossos clientes
        </p>
        <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {clients.map((client) =>
          <div
            key={client.id}
            className="flex h-16 items-center justify-center rounded-lg border border-slate-200 bg-white px-3 text-center text-xs font-semibold text-slate-500">

              {client.name}
            </div>
          )}
        </div>

        <div className="mt-10">
          <div className="mb-4 flex items-center justify-center gap-2">
            <ShieldCheck className="h-4 w-4 text-cyan-600" aria-hidden="true" />
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-500">Somos Credenciados</p>
          </div>
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-4 lg:grid-cols-8">
            {partners.map((partner) =>
            <div
              key={partner.id}
              title={partner.name}
              className="flex h-16 items-center justify-center rounded-lg border border-slate-200 bg-white px-3">

                <img
                src={partner.logo}
                alt={partner.name}
                className="max-h-8 w-auto object-contain" />

              </div>
            )}
          </div>
        </div>
      </Container>
    </section>);

}

export default TrustBar;
